import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AboutUsAccordion = () => (
    <Accordion
        disableGutters
        square
        elevation={0}
        sx={{
            maxWidth: 900,
            mx: 'auto',
            mt: 5,
            backgroundColor: '#f4f4f4',
            '&:before': {
                display: 'none',
            }
        }}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#003366' }} />}
            aria-controls="about-us-content"
            id="about-us-header"
            sx={{
                px: 2,
                '& .MuiAccordionSummary-content': { m: 0 },
                maxWidth: 200,
                mx: 'auto'
            }}
        >
            <Typography
                variant="h6"
                fontWeight={600}
                color="#003366"
                sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
            >
                About Us
            </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ px: 2, pb: 3, color: '#333', fontSize: '1.05rem', lineHeight: 1.8 }}>
            <Typography sx={{ textAlign: 'justify', mb: 2 }}>
                Welcome to <strong>Sahil Holidays</strong>, your trusted travel partner for over 15 years.
                Based in Chennai, we’re a full-service travel company committed to turning your travel dreams
                into memorable experiences. Whether you’re booking flights, hotels, custom tour packages, or
                need visa assistance— we’ve got you covered.
            </Typography>

            <Typography sx={{ textAlign: 'justify', mb: 2 }}>
                We specialize in domestic and international holidays: romantic getaways, family vacations,
                adventure tours, and corporate travel. With 24/7 support and a dedicated team, we ensure a
                smooth, personalized journey from booking to return.
            </Typography>

            <Typography sx={{ whiteSpace: 'pre-line' }}>
                <strong>Our Company Address</strong>:{'\n'}
                24, Strotten Muthia Street,{'\n'}
                Chennai.
                {'\n\n'}
                <strong>Contact No:</strong> +91 72004 92107{'\n'}
                <strong>Email ID:</strong> Sahiltours72@gmail.com
                {'\n\n'}
                <em>Sahil Jain</em>
            </Typography>
        </AccordionDetails>
    </Accordion>
);

export default AboutUsAccordion;
